import type { FunctionComponent, ReactNode } from "react";

import type {
  BurgerMenuItem,
  BurgerMenuItemChildren,
} from "~/lib/app/hooks/scmp-pwa-burger-menu-config";

import { Children, Container, Item, ItemText, Label } from "./styles";

type Props = {
  className?: string;
  items: BurgerMenuItem[];
  label?: string;
  onClick?: (name: string, headerName: string) => void;
  type: string;
};
export const MenuItemAccordionList: FunctionComponent<Props> = ({
  className,
  items,
  label,
  onClick,
  type,
}) => {
  const renderChildren = (children: BurgerMenuItemChildren[], headerName: string) =>
    children?.map((child, index) => (
      <Item
        key={index}
        pathname={child?.urlAlias ?? child?.linkHref ?? ""}
        target={child.isExternal ? "_blank" : undefined}
        onClick={() => onClick?.(child.text, headerName)}
      >
        <ItemText>{child.text}</ItemText>
      </Item>
    ));

  const renderMenuItems = () => {
    const withoutChildrenList: ReactNode[] = [];
    const menuItems = items.map((item, index) => {
      if (!item?.children) {
        withoutChildrenList.push(
          <Item
            key={index}
            pathname={item?.urlAlias ?? item?.linkHref ?? ""}
            target={item.isExternal ? "_blank" : undefined}
            onClick={() => onClick?.(item.text, label ?? "")}
          >
            <ItemText>{item.text}</ItemText>
          </Item>,
        );
        return null;
      }
      return (
        <Container className={className} key={index}>
          <Label>{item.text}</Label>
          <Children $type={type}>{renderChildren(item.children, item.text)}</Children>
        </Container>
      );
    });

    return { menuItems, withoutChildrenList };
  };

  const { menuItems, withoutChildrenList } = renderMenuItems();
  return (
    <>
      {menuItems}

      {withoutChildrenList.length > 0 && (
        <Container className={className}>
          <Label>{label}</Label>
          <Children $type={type}>{withoutChildrenList}</Children>
        </Container>
      )}
    </>
  );
};
